import React, { useMemo } from 'react';
import { Card, Modal } from 'antd';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { CiPrefinInterestDetail } from 'services/clientInvoice';
import { toCurrency } from 'utils/utils';

type LateChargeListModalProps = {
  onCancel: () => void;
  visible: boolean;
  list?: Array<CiPrefinInterestDetail>;
  currcode: string;
};

const PrefinInterestListModal = (props: LateChargeListModalProps) => {
  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'libasis',
        width: '100px',
        render: (val, record) => toCurrency(val, props.currcode),
      },
      {
        dataIndex: 'listartdate',
        width: '100px',
      },
      {
        dataIndex: 'lienddate',
        width: '100px',
      },
      {
        dataIndex: 'linbdays',
        width: '100px',
      },
      {
        dataIndex: 'prefinnominalrate',
        width: '100px',
      },
      {
        dataIndex: 'licalculatedamount',
        width: '100px',
        render: (val, record) => toCurrency(val, props.currcode),
      },
    ],

    []
  );

  return (
    <Modal
      visible={props.visible}
      onCancel={props.onCancel}
      width={1400}
      className="fitcontent"
      footer={null}
    >
      <Card>
        <DataGrid
          titleComcode="ciPrefinInterestDetailList"
          columns={columns}
          dataSource={props.list}
          rowKey="cisid"
          scroll={{ x: 1200, y: 360 }}
          hideFilters
        />
      </Card>
    </Modal>
  );
};

export default PrefinInterestListModal;
